import type { Mandat } from "./Mandat";
import type { PersonneInfosPrivees } from "./PersonneInfosPrivees";

export enum PersonneDataSource {
  RNE = "RNE",
  SDEA = "SDEA",
}

interface PersonneBase {
  nom: string;
  prenom: string;
  dateNaissance: Date;
  sexe?: "M" | "F";
}

export interface Personne extends PersonneBase {
  id: string;
  categorieSocioProfessionnelle?: string;
  mandats?: Array<Mandat>;
  source: PersonneDataSource;
}

export interface PersonneCreateDto extends PersonneBase {
  sexe: "M" | "F";
}

export interface PersonnesFusionDto {
  idPersonneAGarder: string;
  idPersonneAFusionner: string;
}

export interface PersonneWithInfosPrivees extends Personne {
  infosPrivees: PersonneInfosPrivees;
}
